import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import useTable from "../../../../components/UseTable/useTable";
import { TableBody, TableRow, TableCell, Grid } from "@material-ui/core";
// import CardBody from '../../../components/Card/CardBody'
// import Card from '../../../components/Card/Card'

const styles = (theme) => ({});
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      // backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const useStyles = makeStyles(styles);

const headCells = [{ id: "Pathology Test", label: "Pathology Test" }];

const PathologyNotesData = (props) => {
  const classes = useStyles();
  const { pathologyTest } = props;
  const { TblContainer, TblHead } = useTable(pathologyTest, headCells);

  return (
    <div>
      <Grid>
        <Grid item xs={12} sm={12} md={12}>
          {/* <Card style={{ marginTop:1 }}> */}
          {/* <CardBody> */}
          {pathologyTest !== undefined ? (
            <div>
              <TblContainer>
                <TblHead style={{ backgroundColor: "white" }} />
                <TableBody>
                  {pathologyTest.attributes.pathology_note ===
                  null ? null : pathologyTest.attributes.pathology_note.hasOwnProperty(
                      "test_data"
                    ) ? (
                    <React.Fragment>
                      {pathologyTest.attributes.pathology_note.test_data.map(
                        (item) => (
                          <StyledTableRow key={item.id}>
                            <TableCell>{item.test_name}</TableCell>
                          </StyledTableRow>
                        )
                      )}
                    </React.Fragment>
                  ) : null}
                  {pathologyTest.attributes.pathology_note ===
                  null ? null : pathologyTest.attributes.pathology_note.hasOwnProperty(
                      "tests"
                    ) ? (
                    <React.Fragment>
                      {pathologyTest.attributes.pathology_note.tests.map(
                        (item) => (
                          <StyledTableRow key={item}>
                            <TableCell>{item}</TableCell>
                          </StyledTableRow>
                        )
                      )}
                    </React.Fragment>
                  ) : null}
                </TableBody>
              </TblContainer>
            </div>
          ) : null}
          {/* </CardBody> */}
          {/* </Card> */}
        </Grid>
      </Grid>
    </div>
  );
};

export default PathologyNotesData;
